// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2CXP8","logo":"Navbar_logo__1CJp5"};